import { Box, FormControl } from '@chakra-ui/react'

import { FormLabel } from '../../components/FormLabel'
import type { InputGroupProps } from '../../components/InputGroup'
import { InputGroup } from '../../components/InputGroup'

interface LocalInputGroupProps extends InputGroupProps {
  label: string
  name?: string
  id?: string
  tooltip?: string
  optional?: boolean
  defaultValue?: string
  isDisabled?: boolean
}

export const LocalInputGroup = ({ label, name, tooltip, optional, ...rest }: LocalInputGroupProps) => {
  return (
    <FormControl>
      <FormLabel tooltip={tooltip}>{label}</FormLabel>

      <InputGroup {...rest} />
    </FormControl>
  )
}

export const IndividualDiscountsGroup = ({ children }: { children: React.ReactNode }) => {
  return <Box sx={{ display: 'grid', gap: 8 }}>{children}</Box>
}

export const IndividualDiscountsWrapper = ({ children }: { children: React.ReactNode }) => {
  return (
    <Box
      sx={{
        display: 'grid',
        rowGap: {base: 6, md: 12},
        columnGap: 16,
        width: '100%',
        alignContent: 'start',
        alignItems: 'start',
        gridTemplateColumns: {
          base: '1fr',
          md: '1fr 1fr',
        },
        padding: 4,
      }}
    >
      {children}
    </Box>
  )
}
